// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__KPlq_","title":"styles_title__3kef3","subtitle":"styles_subtitle__1feXe"};